<template>
    <div class="profile_edit">
        <div class="container">
            <h1 class="title">Update Profile</h1>
            <p class="desc">Please update your profile before use this app!</p>

            <form id="edit-profile" @submit.prevent="editProfile()">
				<div class="form-group">
					<div v-if="sukses" class="alert alert-success" role="alert">{{sukses.message}}</div>
				</div>
                <div class="row">
                    <div class="col-lg-6">
						<div class="form-row">
							<div class="form-group col-sm-6">
								<label for="name">First Name<span class="text-danger font-italic">*</span></label>
								<input type="text" v-model="datainvestor.first_name" v-validate="'required'" class="capitalize form-control" id="first_name" name="first_name">
								<div v-if="message.first_name" class="text-danger">
									{{message.first_name[0]}}
								</div>
								<div v-if="$v.datainvestor.first_name.$error" class="text-danger">
									<small class="px-2" v-if="!$v.datainvestor.first_name.required">First Name required</small>
								</div>
							</div>
							<div class="form-group col-sm-6">
								<label for="name">Last Name<span class="text-danger font-italic">*</span></label>
								<input type="text" v-model="datainvestor.last_name" v-validate="'required'" class="capitalize form-control" id="last_name" name="last_name">
								<div v-if="message.last_name" class="text-danger">
									{{message.last_name[0]}}
								</div>
								<div v-if="$v.datainvestor.last_name.$error" class="text-danger">
									<small class="px-2" v-if="!$v.datainvestor.last_name.required">Last Name required</small>
								</div>
							</div>
						</div>
						<div class="form-group">
							<label for="phone">Phone<span class="text-danger font-italic">*</span></label>
							<vue-tel-input v-bind="bindProps" v-model="datainvestor.phone" @input="validateFirstLetter" @validate="validatePhone" v-on:country-changed="countryChanged"></vue-tel-input>
							<!-- <VuePhoneNumberInput v-model="datainvestor.datainvestor.phone" default-country-code="ID"/> -->
							<!-- <input type="text" v-model="datainvestor.phone" class="form-control" v-validate="'required'" id="phone" name="phone"> -->
							<div v-if="message.phone" class="text-danger">
								{{message.phone[0]}}
							</div>
							<div v-else-if="$v.datainvestor.phone.$error" class="text-danger">
									<small class="px-2" v-if="!$v.datainvestor.phone.required">Phone required</small>
									<small class="px-2" v-else-if="!$v.datainvestor.phone.minLength">Phone most min {{ $v.datainvestor.phone.$params.minLength.min }}</small>
									<small class="px-2" v-else-if="!$v.datainvestor.phone.maxLength">Phone most max {{ $v.datainvestor.phone.$params.maxLength.max }}</small>
							</div>
							<!-- <div v-if="submitted && datainvestor.phone.length<=6" class="text-danger">
								Phone is required
							</div> -->
							<div v-else-if="submitted && validPhone && datainvestor.phone[0] !== '+'" class="text-danger">
								Phone must have a country code!
							</div>
						</div>
                        <div class="form-group">
							<label for="dob">Date of Birth<span class="text-danger font-italic">*</span></label>
							<input type="date" v-model="datainvestor.dob" v-validate="'required'" class="form-control" id="dob" name="dob" placeholder="yyyy-mm-dd" pattern="(?:19|20)\[0-9\]{2}-(?:(?:0\[1-9\]|1\[0-2\])-(?:0\[1-9\]|1\[0-9\]|2\[0-9\])|(?:(?!02)(?:0\[1-9\]|1\[0-2\])-(?:30))|(?:(?:0\[13578\]|1\[02\])-31))">
							<!-- <div v-if="validation" class="text-danger">
								Date is required
							</div> -->
							<div v-if="$v.datainvestor.dob.$error" class="text-danger">
									<small class="px-2" v-if="!$v.datainvestor.dob.required">Date of Birth required</small>
								</div>
							<div v-if="message.dob" class="text-danger">
								{{message.dob[0]}}
							</div>
						</div>
                        <div class="form-row">
                            <div class="form-group col-sm-6">
                                <label for="country">Country<span class="text-danger font-italic">*</span></label>
								<!-- <VueCountryRegionSelect v-model="datainvestor.datainvestor.country" :country="country" topCountry="US" class="custom-select" id="country" name="country"/> -->
								<!-- <country-select v-model="datainvestor.datainvestor.country" :country="datainvestor.country" topCountry="US" class="custom-select" id="country" name="country"/> -->
								<input type="search" placeholder="Search country" list="country" v-model="datainvestor.country" class="form-control" />
								<datalist id="country">
								<!-- <select name="country" v-model="datainvestor.country" id="country" class="custom-select"> -->
									<!-- v-model="datainvestor.datainvestor.country" -->
									<!-- <option value="" selected>Select Country</option> -->
									<option :value="list.country" v-for="(list, index) in listCountry" :key="index">
										{{list.country}}
									</option>
								</datalist>
                                <!-- <input type="text" v-model="datainvestor.datainvestor.country" class="form-control" id="country" name="country"> -->
                                <div v-if="message.country" class="text-danger">
                                    {{message.country[0]}}
                                </div>
								<div v-if="$v.datainvestor.country.$error" class="text-danger">
									<small class="px-2" v-if="!$v.datainvestor.country.required">Country required</small>
								</div>
                            </div>
                            <div class="form-group col-sm-6">
                                <label for="city">City</label>
                                <input type="text" v-model="datainvestor.city" class="form-control" id="city" name="city">
                                <div v-if="message.city" class="text-danger">
                                    {{message.city[0]}}
                                </div>
								<!-- <div v-if="submitted && errors.has('city')" class="text-danger">
									{{errors.first('city')}}
								</div> -->
								<!-- <div v-if="submitted && datainvestor.city == null" class="text-danger">
									City is required
								</div> -->
                            </div>
                        </div>
                        <div class="form-group">
							<label for="address">Address <span class="text-muted font-weight-normal font-italic">(according to the type of identity you have listed)</span></label>
							<textarea v-model="datainvestor.address" class="form-control" id="address" rows="5"></textarea>
							<div v-if="message.address" class="text-danger">
								{{message.address[0]}}
							</div>
							<!-- <div v-if="submitted && errors.has('address')" class="text-danger">
								{{errors.first('address')}}
							</div> -->
							<!-- <div v-if="submitted && datainvestor.address == null" class="text-danger">
								Address is required
							</div> -->
						</div>
                    </div>
                    <div class="col-lg-6">
                        
                        
                        <div class="form-group">
							<label for="identity_type">Identity type<span class="text-danger font-italic">*</span></label>
							<!-- <input type="search" placeholder="Search" v-model="datainvestor.identity_type" list="type" id="identity_type" v-validate="'required'" class="form-control" />
							<datalist class="" id="type"> -->
							<select v-model="datainvestor.identity_type" class="form-control" id="identity_type">
								<!-- <option selected disabled>Choose..</option> -->
								<option value="ID_CARD">E-KTP</option>
								<option value="PASSPORT">PASSPORT</option>
								<option value="DRIVING_LICENCE">DRIVING LICENSE</option>
							</select>
							<!-- <div v-if="validation" class="text-danger">
								Identity Type is Required
							</div> -->
							<div v-if="message.identity_type" class="text-danger">
								{{message.identity_type[0]}}
							</div>
							<div v-if="submitted && errors.has('identity_type')" class="text-danger">
								{{errors.first('identity_type')}}
							</div>
							<div v-if="$v.datainvestor.identity_type.$error" class="text-danger">
								<small class="px-2" v-if="!$v.datainvestor.identity_type.required">Identity Type is required</small>
							</div>
						</div>
						<div class="form-group">
							<label for="identity_number">Identity Number <span class="text-danger font-italic">*</span> <span class="text-muted font-weight-normal font-italic">(according to the type of identity you have listed)</span></label>
							<input type="text" v-if="datainvestor.identity_type == 'PASSPORT'" v-model="datainvestor.identity_number" v-validate="'required'" class="form-control" id="identity_number" name="identity_number">
							<input type="tel" v-on:keypress="NumbersOnly" v-else v-model="datainvestor.identity_number" v-validate="'required|numeric'" class="form-control" id="identity_number" name="identity_number">
							<!-- <div v-if="validation" class="text-danger">
								Identity Number is required
							</div> -->
							<div v-if="message.identity_number" class="text-danger">
								{{message.identity_number[0]}}
							</div>
							<div v-if="$v.datainvestor.identity_number.$error" class="text-danger">
								<small class="px-2" v-if="!$v.datainvestor.identity_number.required">Identity Number is required</small>
							</div>
						</div>
                        <div class="form-row">
                            <div class="form-group col-sm-6">
                                <label for="identity_number">Identity Photo <span class="text-danger font-italic">*</span> </label>
								<b-tooltip target="tooltip-target-1" triggers="hover">
									Uploaded files have a maximum size of 2 MB. Make sure the identity in the comparison file matches the previously uploaded file. Example : ID Card, Passport or Driving License
								</b-tooltip>
                                <div class="custom-file photo_upload" id="tooltip-target-1">
                                    <label for="identity_file" class="custom-file-upload">
                                        Upload Photo
                                    </label>
                                    <!-- <input type="file" ref="fileInput" @change="previewImage" accept="all" class="" name="identity_file" id="identity_file"> -->
                                    <input type="file" @change="onFileChange" accept="image/*" class="" name="identity_file" id="identity_file">
                                    <!-- <label class="custom-file-label" for="customFile">Choose file</label> -->
                                </div>
                                <template v-if="preview">
                                    <img :src="preview" class="img_identity" />
                                    <!-- <p class="mb-0 image_name">{{ image.name }}</p> -->
                                </template>
								<template v-else>
                                    <img :src="dataakun.identity_file" class="img_identity2" />
                                    <!-- <p class="mb-0 image_name">{{ image.name }}</p> -->
                                </template>
                                <div v-if="message.identity_file" class="text-danger">
                                    {{message.identity_file[0]}}
                                </div>
								<!-- <div v-if="$v.datainvestor.identity_file.$error" class="text-danger">
									<small class="px-2" v-if="!$v.datainvestor.identity_file.required">Identity Photo is required</small>
								</div> -->
								<div v-if="error.identity_file !== ''" class="text-danger">
									{{error.identity_file}}
								</div>
								<!-- <div v-if="submitted && errors.has('identity_file')" class="text-danger">
									{{errors.first('identity_file')}}
								</div> -->
                            </div>
                            <div class="form-group col-sm-6">
                                <label for="comparison_file">Comparison File <span class="text-danger font-italic">*</span> </label>
								<b-tooltip target="tooltip-target-2" triggers="hover">
									Uploaded files have a maximum size of 2 MB. Make sure the identity in the comparison file matches the previously uploaded file. Example : Bank Statement or Utility Bill
								</b-tooltip>
                                <div class="custom-file photo_upload" id="tooltip-target-2">
                                    <label for="comparison_file" class="custom-file-upload">
                                        Upload Photo
                                    </label>
                                    <!-- <input type="file" ref="fileInput" @change="previewImage" accept="all" class="" name="identity_file" id="identity_file"> -->
                                    <input type="file" @change="onFileCompareChange" accept="image/*" class="" name="comparison_file" id="comparison_file">
                                    <!-- <label class="custom-file-label" for="customFile">Choose file</label> -->
                                </div>
                                <template v-if="viewCompare">
                                    <img :src="viewCompare" class="img_identity3" />
                                    <!-- <p class="mb-0 image_name">{{ image.name }}</p> -->
                                </template>
								<template v-else>
                                    <img :src="dataakun.comparison_file" class="img_identity3" />
                                    <!-- <p class="mb-0 image_name">{{ image.name }}</p> -->
                                </template>
                                <div v-if="message.comparison_file" class="text-danger">
                                    {{message.comparison_file[0]}}
                                </div>
								<!-- <div v-if="$v.datainvestor.comparison_file.$error" class="text-danger">
									<small class="px-2" v-if="!$v.datainvestor.comparison_file.required">Comparison File is required</small>
								</div> -->
								<div v-if="error.comparison_file !== ''" class="text-danger">
									{{error.comparison_file}}
								</div>
								<!-- <div v-if="submitted && errors.has('comparison_file')" class="text-danger">
									{{errors.first('comparison_file')}}
								</div> -->
                            </div>
                            <div class="form-group col-sm-6">
                                <label for="identity_number">Selfie Image with Identity Card<span class="text-danger font-italic">*</span></label>
								<b-tooltip target="tooltip-target-3" triggers="hover">
									Uploaded files have a maximum size of 2 MB. Make sure the identity in the comparison file matches the previously uploaded file.
								</b-tooltip>
                                <div class="custom-file photo_upload" id="tooltip-target-3">
                                    <label for="selfie_image" class="custom-file-upload">
                                        Upload Photo
                                    </label>
                                    <input type="file" @change="onFileSelfieChange" accept="image/*" class="" name="selfie_image" id="selfie_image">
                                    <!-- <label class="custom-file-label" for="customFile">Choose file</label> -->
                                </div>
                                <template v-if="viewSelfie">
                                    <img :src="viewSelfie" class="img_identity2" />
                                    <!-- <p class="mb-0 image_name">{{ image.name }}</p> -->
                                </template>
								<template v-else>
                                    <img :src="dataakun.selfie_image" class="img_identity2" />
                                    <!-- <p class="mb-0 image_name">{{ image.name }}</p> -->
                                </template>
                                <div v-if="message.selfie_image" class="text-danger">
                                    {{message.selfie_image[0]}}
                                </div>
								<!-- <div v-if="$v.datainvestor.selfie_image.$error" class="text-danger">
									<small class="px-2" v-if="!$v.datainvestor.selfie_image.required">Selfie Image is required</small>
								</div> -->
								<div v-if="error.selfie_image !== ''" class="text-danger">
									{{error.selfie_image}}
								</div>
								<!-- <div v-if="submitted && errors.has('selfie_image')" class="text-danger">
									{{errors.first('selfie_image')}}
								</div> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-4 ml-auto">
                        <button type="submit" class="btn btn_red btn-block" id="btnsubmit" :disabled="loading">
                            <span id="spinnerSubmit" class="spinner-border d-none spinner-border-sm mr-2"></span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 31.5 31.5">
                                <g id="save_icon" transform="translate(-223.85 -684)">
                                    <path id="Icon_awesome-save" data-name="Icon awesome-save" d="M30.511,9.136l-5.9-5.9a3.375,3.375,0,0,0-2.386-.989H3.375A3.375,3.375,0,0,0,0,5.625v24.75A3.375,3.375,0,0,0,3.375,33.75h24.75A3.375,3.375,0,0,0,31.5,30.375V11.523a3.375,3.375,0,0,0-.989-2.386Z" transform="translate(223.85 681.75)" fill="#fff" opacity="0.5"/>
                                    <path id="Union_5" data-name="Union 5" d="M-2894,18a5,5,0,0,1,5-5,5,5,0,0,1,5,5,5,5,0,0,1-5,5A5,5,0,0,1-2894,18Zm-6-9a1,1,0,0,1-1-1V1a1,1,0,0,1,1-1h17a1,1,0,0,1,1,1V8a1,1,0,0,1-1,1Z" transform="translate(3129 688)" fill="#fff"/>
                                </g>
                            </svg>
                            Save Profile
                        </button>
                    </div>
					<div class="col-lg-2">
						<button class="btn btn_outline_red btn-block" @click.prevent="logout()">
							<svg xmlns="http://www.w3.org/2000/svg" width="18" height="13.721" viewBox="0 0 18 13.721">
								<g id="logout_icon" transform="translate(-33.932 -435.466)">
									<path id="Icon_awesome-sign-out-alt" data-name="Icon awesome-sign-out-alt" d="M19.178,11.963l-6,6a.859.859,0,0,1-1.465-.61V13.924H6.857A.855.855,0,0,1,6,13.07V9.641a.855.855,0,0,1,.857-.857h4.858V5.355a.859.859,0,0,1,1.465-.61l6,6A.864.864,0,0,1,19.178,11.963Z" transform="translate(32.505 430.971)" fill="#1a1818" opacity="0.5"/>
									<path id="Icon_awesome-sign-out-alt-2" data-name="Icon awesome-sign-out-alt" d="M6.858,17.785V16.357a.43.43,0,0,0-.428-.428h-3a1.143,1.143,0,0,1-1.143-1.141V7.929A1.143,1.143,0,0,1,3.429,6.786h3a.43.43,0,0,0,.43-.429V4.928a.43.43,0,0,0-.43-.428h-3A3.429,3.429,0,0,0,0,7.929v6.858a3.429,3.429,0,0,0,3.429,3.429h3a.43.43,0,0,0,.43-.431Z" transform="translate(33.932 430.97)" fill="#1a1818"/>
								</g>
							</svg>
							Logout
						</button>
					</div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import jwt_decode from "jwt-decode"
import swal from "sweetalert"
import { required, minLength, maxLength  } from "vuelidate/lib/validators";

// import VuePhoneNumberInput from 'vue-phone-number-input';
// import 'vue-phone-number-input/dist/vue-phone-number-input.css';

import country from '../country.json'

// import VueCountryRegionSelect from 'vue-country-region-select'

export default {
    name: "EditProfile",
	components: {
		// VuePhoneNumberInput,
		// VueCountryRegionSelect
	},
	data(){
		return{
			phoneFirstTimeLoad: 0,
            phoneValid: true,
			dataakun: [],
			akunemail: '',
			message: '',
			validPhone: false,
			sukses: '',
			status: false,
            preview: null,
            viewSelfie: null,
            viewCompare: null,
            image: null,
            imageSelfie: null,
            imageCompare: null,
			loading: false,
			submitted: false,
			imageName: '',
			nameFile: '',
			selfieImage: '',
			compareImage: '',
			listCountry: country,
			country: null,
            bindProps: {
                mode: "international",
                placeholder: "Enter a phone number",
                required: false,
                enabledCountryCode: true,
                enabledFlags: true,
                autocomplete: "off",
                name: "telephone",
				// defaultCountry: 62,
                maxLen: 25,
				autoFormat: true,
				showDialCode: true,
				// validCharactersOnly: true,
                inputOptions: {
					showDialCode: true,
					maxlength: 17,
					type: 'tel'
                },
				dropdownOptions: {
					showSearchBox: true,
					showFlags: true,
					width: '400px',
					showDialCodeInList: true,
				}
            },
			validation: false,
			datainvestor:{
				id:"",
				first_name:null,
				last_name:null,
				// name:null,
				// username:null,
				// email:null,
				phone:null,
				identity_file:null,
				selfie_image:null,
				comparison_file:null,
				identity_number: "",
				identity_type: "",
				dob: "",
				city: null,
				country: null,
				address: null,
			},
			error: {
				identity_file: '',
				comparison_file: '',
				selfie_image: ''
			}
		}
	},
	validations: {
		datainvestor:{
			first_name: {
				required,
			},
			last_name: {
				required,
			},
			phone: {
				required,
				minLength: minLength(7),
				maxLength: maxLength(20)
			},
			identity_number: {
				required,
			},
			identity_type: {
				required,
			},
			dob: {
				required,
			},
			country: {
				required,
			},
		}

	},
    async mounted() {
		// if(!this.currentUser) {
		// 	this.$router.push('/login');
		// }

		// this.loading = true
		var token = localStorage.getItem('access_token')
		var access_token = jwt_decode(token)
		const user_id = access_token.user_id
		if(!localStorage.getItem('user_id')){
			localStorage.setItem('user_id', user_id)
		}

		await axios.get(`investor/${localStorage.user_id}/`, {
			headers: {
				'Authorization': `Bearer ${token}`
			}
		})


		.then(result => {
			// console.log('Profile: ', result.data.data)
			this.dataakun = result.data.data
			this.akunemail = result.data.data.email
            this.datainvestor = result.data.data;
			// this.first_name = data.first_name
			// this.last_name = data.last_name
			// this.dob = data.dob
			// this.phone = data.phone
			// this.identity_number = data.identity_number
			// this.identity_type = data.identity_type
			// this.city = data.city
			// this.country = data.country
			// this.address = data.address
			// if(result.data.data.identity_file == null)
            // {
            //   this.$router.push('profile/update')
            // }
		}).catch(() => {
			// console.log('Error Profile: ', err.response)
		})
	},
	methods: {
		NumbersOnly(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
		onFileChange(e){
            var input = e.target;
			const isLt2M = input.files[0].size / 1024 / 1024 < 2;
			if (isLt2M) {
				this.error.identity_file = ''
				if (input.files) {
					var reader = new FileReader();
					reader.onload = (e) => {
						this.preview = e.target.result;
					}
					this.image=input.files[0];
					reader.readAsDataURL(input.files[0]);
				}
				const file = e.target.files[0]
				this.imageName = e.target.files[0];
				this.nameFile = file
			} else{
				// console.log('File more than 2mb.')
				this.error.identity_file = 'File more than 2mb.'
			}
			// console.log(this.nameFile)
		// $('#trade_report_data').css('background-image', 'url(' + Dataisi + ')');
		},
		onFileSelfieChange(e){
			// const file = e.target.files[0]
            var input2 = e.target;
			const isLt2M = input2.files[0].size / 1024 / 1024 < 2;
			if (isLt2M){
				this.error.selfie_image = ''
				if (input2.files) {
					var reader = new FileReader();
					reader.onload = (e) => {
						this.viewSelfie = e.target.result;
					}
					this.imageSelfie=input2.files[0];
					reader.readAsDataURL(input2.files[0]);
				}
				this.selfieImage = e.target.files[0];
			} else{
				// console.log('File more than 2mb.')
				this.error.selfie_image = 'File more than 2mb.'
			}
			// this.nameFile = file
			// console.log(this.selfieImage)
		// $('#trade_report_data').css('background-image', 'url(' + Dataisi + ')');
		},
		onFileCompareChange(e){
			// const file = e.target.files[0]
            var fileInput = e.target;
			const isLt2M = fileInput.files[0].size / 1024 / 1024 < 2;
			if (isLt2M) {
				this.error.comparison_file = ''
				if (fileInput.files) {
					var reader = new FileReader();
					reader.onload = (e) => {
						this.viewCompare = e.target.result;
					}
					this.imageCompare=fileInput.files[0];
					reader.readAsDataURL(fileInput.files[0]);
				}
				this.compareImage = e.target.files[0];
			}else{
				// console.log('File more than 2mb.')
				this.error.comparison_file = 'File more than 2mb.'
			}
			// this.nameFile = file
			// console.log(this.compareImage)
		// $('#trade_report_data').css('background-image', 'url(' + Dataisi + ')');
		},
		// sendUser(dataakun) {
		// 	this.datainvestor = dataakun;
		// 	console.log("Get Data Investor", this.datainvestor)
		// },
		countryChanged(country) {
            // console.log("countryChanged")
            this.phoneFirstTimeLoad++;
            let countryCode = country.dialCode;
			// console.log('Dial Code: ', this.country)

            if (this.phoneFirstTimeLoad > 0) {

                const myPromise = new Promise((resolve) => {
                    resolve((this.phone = ""));
                });

                myPromise.then(() => {
                    if(this.datainvestor.phone !== null || ''){
                        // console.log('datapertama')
						// this.datainvestor.phone = `+${countryCode}`
						// console.log('Country Phone: ', this.datainvestor.phone)
						this.datainvestor.phone = `${this.datainvestor.phone}`
                    }else{
						// console.log('phone else')
                        this.datainvestor.phone = `+${countryCode}`;
                    }

                });
            }
        },
        // countryChanged(country) {
        //     this.country = '+' + country.dialCode
        // },
        validatePhone(country) {
            // console.log("validatePhone")
            this.phoneValid = country.valid;
        },
        validateFirstLetter() {
            // console.log("validateFirstLetter")
            if (this.datainvestor.phone[0] != "+") {
                this.phoneValid = false;
            }
        },
		editProfile(){
			this.submitted = true
			this.loading = true
			document.getElementById('btnsubmit').disabled = true
			document.getElementById('spinnerSubmit').classList.add('d-block')
			document.getElementById('spinnerSubmit').classList.remove('d-none')
			// console.log('Identity Photo: ', this.imageName)
			// console.log('Selfie Image: ', this.selfieImage)
			// if(this.akunemail == this.datainvestor){
				let data = new FormData()
				data.append('id', this.dataakun.id)
				data.append('first_name', this.datainvestor.first_name)
				data.append('last_name', this.datainvestor.last_name)
				// data.append('name', this.datainvestor.name)
				// data.append('username', this.datainvestor.username)
				// data.append('email', this.datainvestor.email)
				data.append('phone', this.datainvestor.phone)
				if(this.imageName == ""){
                    data.delete('identity_file')
                    // data.append('identity_file', this.identity_file)
                    // console.log('Identity Photo IF 1: ')
				} else if(this.imageName !== ""){
                    data.append('identity_file', this.imageName)
                    // data.append('identity_file', this.identity_file)
                    // console.log('Identity Photo IF 2: ')
					// data.append('identity_file', this.imageName)
				} else{
					// data.append('identity_file', this.imageName)
                    // console.log('Identity Photo Else: ')
                    data.append('identity_file', this.datainvestor.identity_file)
                }

				if(this.compareImage == ""){
                    // data.delete('comparison_file')
                    // data.append('comparison_file', this.comparison_file)
                    // console.log('Compare File IF 1: ')
				} else if(this.compareImage !== ""){
                    // data.append('comparison_file', this.comparison_file)
					data.append('comparison_file', this.compareImage)
                    // console.log('Compare File IF 2: ')
                    // data.append('comparison_file', this.compareImage)
                }else{
                    // console.log('Compare File Else: ')
                    // data.append('comparison_file', this.compareImage)
                    data.append('comparison_file', this.datainvestor.comparison_file)
                }

				if(this.selfieImage == ""){
					data.delete('selfie_image')
					// data.append('selfie_image', this.selfieImage)
                    // data.append('selfie_image', this.selfie_image)
                    // console.log('Selfie File IF 1: ')
				} else if(this.selfieImage !== ""){
                    // data.append('selfie_image', this.selfie_image)
                    data.append('selfie_image', this.selfieImage)
                    // console.log('Selfie File IF 2: ')
                }else{
                    // console.log('Selfie File Else: ')
                    // data.append('selfie_image', this.selfieImage)
                    data.append('selfie_image', this.datainvestor.selfie_image)
                }

				// data.append('selfie_image', this.selfie_image)
				if(this.datainvestor.dob == "" || this.datainvestor.dob == null)
				{
					data.append('dob', "")
				} else{
					data.append('dob', this.datainvestor.dob)
				}

				// if(this.datainvestor.identity_number !== "" || this.datainvestor.identity_number !== null)
				// {
				// 	data.delete('identity_number')
				// } else{

				// }
				data.append('identity_number', this.datainvestor.identity_number)

				if(this.datainvestor.identity_type == "" || this.datainvestor.identity_type == null)
				{
					data.append('identity_type', "")
				} else{
					data.append('identity_type', this.datainvestor.identity_type)
				}

				// data.append('identity_number', this.identity_number)
				// data.append('identity_type', this.identity_type)

				// if (this.identity_type === null) {
				// 	data.append('identity_type', this.identity_type)
				// } else{
				// 	data.append('identity_type', this.identity_type)
				// }

				// if(this.datainvestor.country == ('' || null || 'null' || 'false' || 'true'))
				// {
				// 	data.append('country', null)
				// } else{
				// 	}
				// data.append('country', this.datainvestor.country)
				// data.append('country', this.datainvestor.country)
				if(this.datainvestor.country == "" || this.datainvestor.country == null)
				{
					data.append('country', "")
				} else{
					data.append('country', this.datainvestor.country)
				}
				if(this.datainvestor.city == "" || this.datainvestor.city == null)
				{
					data.append('city', "")
				} else{
					data.append('city', this.datainvestor.city)
				}

				if(this.datainvestor.address == '' || this.datainvestor.address == null)
				{
					data.append('address', "")
				} else{
					data.append('address', this.datainvestor.address)
				}

				if(!this.selfieImage && !this.datainvestor.selfie_image){
					this.error.selfie_image = 'Selfie Image is required.'
					document.getElementById('btnsubmit').disabled = false
					document.getElementById('spinnerSubmit').classList.add('d-none')
					document.getElementById('spinnerSubmit').classList.remove('d-block')
				}
				if(!this.compareImage && !this.datainvestor.comparison_file){
					this.error.comparison_file = 'Comparison File is required.'
					document.getElementById('btnsubmit').disabled = false
					document.getElementById('spinnerSubmit').classList.add('d-none')
					document.getElementById('spinnerSubmit').classList.remove('d-block')
				}
				if(!this.imageName && !this.datainvestor.identity_file){
					this.error.identity_file = 'Identity File is required.'
					document.getElementById('btnsubmit').disabled = false
					document.getElementById('spinnerSubmit').classList.add('d-none')
					document.getElementById('spinnerSubmit').classList.remove('d-block')
				}
			this.$v.datainvestor.$touch()
				if(!this.$v.datainvestor.$invalid && (this.selfieImage || this.datainvestor.selfie_image) && (this.compareImage || this.datainvestor.comparison_file) && (this.imageName || this.datainvestor.identity_file)){
						this.loading = true
						if(this.datainvestor.phone.length<6 || this.datainvestor.phone == '' || this.datainvestor.phone[0] != "+"){
							this.loading = false;
							this.validPhone = true;
							document.getElementById('btnsubmit').disabled = false
							document.getElementById('spinnerSubmit').classList.add('d-none')
							document.getElementById('spinnerSubmit').classList.remove('d-block')
						}
						else if(this.imageName == null && this.datainvestor.identity_file == null){
							this.loading = false;
							this.validPhone = true;
							this.status = true;
						}else if(this.compareImage == null && this.datainvestor.comparison_file == null){
							this.loading = false;
							this.validPhone = true;
							this.status = true;
						}else if(this.selfieImage == null && this.datainvestor.selfie_image == null){
							this.loading = false;
							this.validPhone = true;
							this.status = true;
						}
						else{
							if((this.imageName == null && this.datainvestor.identity_file == null) || this.error.identity_file !== ''){
								this.loading = false;
								this.validPhone = true;
								this.status = true;
								document.getElementById('btnsubmit').disabled = false
								document.getElementById('spinnerSubmit').classList.add('d-none')
								document.getElementById('spinnerSubmit').classList.remove('d-block')

							}else {
								if((this.compareImage == null && this.datainvestor.comparison_file == null) || this.error.comparison_file !== ''){
									this.loading = false;
									this.validPhone = true;
									this.status = true;
									document.getElementById('btnsubmit').disabled = false
									document.getElementById('spinnerSubmit').classList.add('d-none')
									document.getElementById('spinnerSubmit').classList.remove('d-block')
								}else{
									if((this.selfieImage == null && this.datainvestor.selfie_image == null) || this.error.selfie_image !== ''){
										this.loading = false;
										this.validPhone = true;
										this.status = true;
										document.getElementById('btnsubmit').disabled = false
										document.getElementById('spinnerSubmit').classList.add('d-none')
										document.getElementById('spinnerSubmit').classList.remove('d-block')
									} else{
										axios.put(`investor/profile/${this.dataakun.id}/`, data)
										.then((response) => {
												// console.log(response);
												// if(response.data.data.status === 200) {
													this.loading = true
													this.validation = false
													this.validPhone = true;
													this.sukses = response.data


													// this.$bvModal.hide('modal-edituser')
													// $(this.$refs.editModal).on("hidden.bs.modal")
													// setTimeout(() => {
														this.$router.push({ path: `/profiling` })
														document.getElementById('btnsubmit').disabled = false
													// }, 2000)
													// window.location.reload()
													// return router.push({
														// name: 'Login'
													// })
												// } else {
												// 	this.loading = false
												// 	// validation.value = response.data.response
												// 	// console.log(validation);
												// }
											}).catch((error) => {
											this.loading = false
											document.getElementById('btnsubmit').disabled = false
											document.getElementById('spinnerSubmit').classList.add('d-none')
											document.getElementById('spinnerSubmit').classList.remove('d-block')
											if (error.status == 400) {
												// this.validation = true
												this.message = error.data.data || error.response.data.data
											} else{
												this.message = error.data.data || error.response.data.data
												swal(error.data.message, '', 'info', {
													buttons: ["Cancel"]
												})
											}
											// console.log(error)
										})
									}
								}
							}
						}
					}else{
						// this.submitted = false
						this.loading = false;
						document.getElementById('btnsubmit').disabled = false
						document.getElementById('spinnerSubmit').classList.add('d-none')
						document.getElementById('spinnerSubmit').classList.remove('d-block')
						// this.validPhone = true;
					}
					this.loading = false

			// }
			// this.loading = false
		},
		logout(){
			swal("Are You Sure to Log Out?", '', "info", {
				buttons: ["Cancel", "Logout"]
			}).then((res) => {
				if(res) {
					this.$store.dispatch('auth/logout', {
				})
					this.$router.push('login')
				} else {
					if(swal.close()){
						console.log("Cancel")
					}
				}
			})

		}
	}
}
</script>

<style scoped>
.capitalize{
    text-transform: capitalize;
}
.profile_edit img.img_identity{
    width: auto;
    height: 80px;
}
.profile_edit img.img_identity2{
    width: auto;
    height: 80px;
}
.profile_edit img.img_identity3{
    width: auto;
    height: 80px;
}
.profile_edit .photo_upload input[type="file"] {
    display: none;
}
.profile_edit .photo_upload .custom-file-upload {
    border: 1px solid #ccc;
    display: inline-block;
    padding: 6px 12px;
    cursor: pointer;
    border-radius: 5px;
    display: flex;
    width: 50%;
    align-items: center;
    justify-content: center;
}
.profile_edit .image_name{
    font-size: 10pt;
}
.profile_edit{
    padding: 40px 0;
}
.profile_edit .title{
    font-weight: 700;
    color: var(--red);
}
.profile_edit .form-group{
    margin-bottom: 5px;
}
.profile_edit .form-group label{
    font-size: 10pt;
    margin: 0;
}
input.form-control{
    padding: 15px;
}

.profile_edit form button.btn_red svg,
.profile_edit form button.btn_outline_red svg{
    margin-right: 10px;
}
.profile_edit form button.btn_red,
.profile_edit form button.btn_outline_red{
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px;
    text-transform: uppercase;
    margin-top: 20px;
}
.profile_edit form button.btn_outline_red:hover > svg path{
	fill: #fff;
}
</style>
